import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faSpinner} from "@fortawesome/free-solid-svg-icons";
export default function Loading(props){

    const visible = props.show  === undefined ? '': props.show === true ? '':'d-none';

    return (
        <div className={`text-center ${visible} `}>
            <FontAwesomeIcon spin={true} icon={faSpinner} className={"fs-1"} /> Proszę czekać, trwa ładowanie treści...
        </div>
    )
}